import React, { createContext, useState, useEffect } from "react";

export const DataContext = createContext();

// Same-origin (the dev server proxies /api to ASP.NET)
const API_BASE_URL = "/api";

export const DataProvider = ({ children }) => {
    const [events, setEvents] = useState([]);
    const [showPastEvents, setShowPastEvents] = useState(false);

    async function fetchEventsFromDb() {
        try {
            const res = await fetch(`${API_BASE_URL}/FacebookEvents`);
            const text = await res.text(); // always read text for better debugging

            if (!res.ok) {
                console.error("Failed fetching events:", res.status, text);
                throw new Error(`Status ${res.status}: ${text}`);
            }

            const data = JSON.parse(text); // parse JSON after reading text
            setEvents(data);
            return data;
        } catch (err) {
            console.error("Error fetching events from DB:", err);
            setEvents([]); // reset on error
            return [];
        }
    }

    // Admin only: the server pulls events from Facebook (it holds the access token)
    // and upserts them into the DB, then we reload from the DB.
    const updateFaceBookEventsDB = async () => {
        const res = await fetch(`${API_BASE_URL}/FacebookEvents/sync`, { method: "POST" });
        const text = await res.text();
        if (!res.ok) {
            console.error("Facebook sync failed:", res.status, text);
            throw new Error(`Facebook sync failed: ${res.status}`);
        }

        await fetchEventsFromDb();
    };

    // Re-fetch DB when toggling past/future
    useEffect(() => {
        fetchEventsFromDb();
    }, [showPastEvents]);

    return (
        <DataContext.Provider
            value={{
                events,
                fetchEvents: fetchEventsFromDb,
                updateFaceBookEventsDB,
                showPastEvents,
                setShowPastEvents
            }}
        >
            {children}
        </DataContext.Provider>
    );
};
